import _ from 'lodash'
import moment from 'moment'

// test: yarn test src/utils/booking/__tests__/BookingBusinessLogic.test.js
export default class BookingBusinessLogic {
  constructor(bookingPresetDataModel) {
    this.bookingPresetDataModel = bookingPresetDataModel
  }

  setBookingPresetDataModel(bookingPresetDataModel) {
    this.bookingPresetDataModel = bookingPresetDataModel
  }

  // 精靈模式，判斷是否需要在分店變更時重新抓取服務
  servicesAreBoundToBranches() {
    const relatesToBranch = this.bookingPresetDataModel.servicesAreRelatedToBranches
    const relatesToStaffs = this.bookingPresetDataModel.servicesAreRelatedToStaffs

    if (relatesToBranch && relatesToStaffs) {
      const displayOrder = this.bookingPresetDataModel.wizardFieldOrder
      return _.get(displayOrder, 'service') === _.get(displayOrder, 'branch') + 1
    }

    return relatesToBranch
  }

  // 精靈模式，判斷是否需要在員工變更時重新抓取服務
  servicesAreBoundToStaffs() {
    const relatesToBranch = this.bookingPresetDataModel.servicesAreRelatedToBranches
    const relatesToStaffs = this.bookingPresetDataModel.servicesAreRelatedToStaffs

    if (relatesToBranch && relatesToStaffs) {
      const displayOrder = this.bookingPresetDataModel.wizardFieldOrder
      return _.get(displayOrder, 'service') === _.get(displayOrder, 'staff') + 1
    }

    return relatesToStaffs
  }

  // 精靈模式，判斷是否需要在分店變更時重新抓取員工
  staffsAreBoundToBranches() {
    const relatesToStaffs = this.bookingPresetDataModel.servicesAreRelatedToStaffs

    if (false === relatesToStaffs) {
      return true
    }

    const displayOrder = this.bookingPresetDataModel.wizardFieldOrder
    return _.get(displayOrder, 'staff') === _.get(displayOrder, 'branch') + 1
  }

  // 精靈模式，判斷是否需要在服務變更時重新抓取員工
  staffsAreBoundToServices() {
    const relatesToStaffs = this.bookingPresetDataModel.servicesAreRelatedToStaffs

    if (false === relatesToStaffs) {
      return false
    }

    const displayOrder = this.bookingPresetDataModel.wizardFieldOrder
    return _.get(displayOrder, 'staff') === _.get(displayOrder, 'service') + 1
  }

  // 一般模式與精靈模式通用，產生時間選項
  generateTimeOptionsForDate(dateString) {
    if (this.bookingPresetDataModel?.startTimeField?.time_condition === 'specified') {
      return (this.bookingPresetDataModel?.startTimeField?.time_options || [])
        .map(option => moment(`${dateString} ${option.value}`))
    }

    const isoWeekday = moment(dateString).isoWeekday()
    const firstOption = this.bookingPresetDataModel?.firstStartTimeOptionForWeekday(isoWeekday)
    const lastOption = this.bookingPresetDataModel?.lastStartTimeOptionForWeekday(isoWeekday)
    const slotMinutes = this.bookingPresetDataModel?.timeOptionGap
    if (!dateString || !firstOption || !lastOption || slotMinutes < 1) {
      return []
    }

    let currentMoment = moment(`${dateString} ${firstOption}`)
    const endMoment = moment(`${dateString} ${lastOption}`)

    const optionMoments = []
    while (currentMoment.isSameOrBefore(endMoment)) {
      optionMoments.push(currentMoment.clone())
      currentMoment.add(slotMinutes, 'minutes')
    }

    return optionMoments
  }

  // 精靈模式，最後會存到資料庫的結束時間。用於：預覽送出結果、佔用檢查
  endDateTimeToSaveInWizard(dateTimeString, serviceDuration) {
    const endSlotMinutes = this.bookingPresetDataModel?.endSlotMinutes || 0
    return moment(dateTimeString)
      .add(serviceDuration, 'minutes')
      .add(endSlotMinutes, 'minutes')
      .subtract((endSlotMinutes + serviceDuration) > 0 ? 1 : 0, 'second')
  }

  // 精靈模式，產生送出到後端 API 所需要的結束時間
  endDateTimeToSubmitInWizard(dateTimeString, serviceDuration) {
    if (this.bookingPresetDataModel?.startAtFieldFormatIsDate) {
      return moment(dateTimeString).endOf('day')
    }

    // NOTE: 不可包含 end slot minutes，後端會自動補上
    return moment(dateTimeString)
      .add(serviceDuration, 'minutes')
  }

  // 一般模式，最後會存到資料庫的結束時間。用於：預覽送出結果、佔用檢查
  endDateTimeToSaveInGeneral(dateTimeString) {
    const endSlotMinutes = this.bookingPresetDataModel?.endSlotMinutes || 0
    return moment(dateTimeString)
      .add(endSlotMinutes, 'minutes')
      .subtract(endSlotMinutes > 0 ? 1 : 0, 'second')
  }
}
